// extracted by mini-css-extract-plugin
export default {"btn":"backToTop_btn__sM9ku"};